module.exports = __webpack_public_path__ + "static/media/1.5 Vinckboons nach_klein.cfcf10eb.jpg";